module.exports = __webpack_public_path__ + "static/media/nodata.dc1d1581.svg";